import { useMediaQuery } from "@noom/wax-component-library";

export const MIN_SCREEN_WIDTH = 900;

export const useDesktopView = (): boolean => {
  return useMediaQuery(`(min-width: ${MIN_SCREEN_WIDTH}px)`)[0];
};
